
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Anne-Lise Cornu, 69, verstorben am 7. April 2020</b>
    <br />
    <br />
    <i>Tochter Céline Fleury-Cornu erzählt: </i>
    <br />
    <p>
  «Am 26. März starb unser Vater Henri-Paul an Covid-19. Wir ahnten schon, dass
  sich auch unsere Mutter Anne-Lise mit dem Virus angesteckt haben könnte. Nach
  seinem Tod blieb sie alleine in ihrer Wohnung im freiburgischen Romont. In den
  ersten Tagen ging es ihr körperlich recht gut. Aber schon am 3. April bemerkte
  eine Nichte am Telefon, dass sie Mühe mit der Atmung hat.
    </p>
    <p>
  Sie kam wie unser Vater ins Kantonsspital Freiburg – an eine Lungenmaschine,
  aber nicht auf die Intensivstation. Unsere Mutter äusserte am Telefon die
  Hoffnung, das Spital wieder verlassen zu können. Ich konnte ihr nicht die
  Wahrheit sagen, sie nicht in den Arm nehmen. Das beschäftigt mich bis heute.
    </p>
    <p>
  Mein jüngerer Bruder Didier lag zu dem Zeitpunkt im selben Spital auf der
  Intensivstation. Ebenfalls wegen Covid-19. Am Tag, als unsere Mutter starb,
  musste er intubiert werden.
    </p>
    <p>
  Der Tod meiner Mutter war für mich, so traurig ich war, fast schon eine
  Erleichterung: Sie durfte einfach einschlafen. Keine Unruhe, keine Angst.
    </p>
    <p>
  Mein Bruder erwachte nach 17 Tagen aus dem Koma – die Ärzte sagten, es sei ein
  Wunder, dass er überlebt habe. Wenn ich an die Wochen im Frühling zurückdenke,
  fühle ich mich noch immer hilflos. Ohnmächtig. Ich plane nicht mehr weit in
  die Zukunft. Ich bin heute ein anderer Mensch. Der Trauerprozess ist langsam
  und beschwerlich – auch weil wir unsere Eltern noch nicht haben beerdigen
  können. Hoffentlich im nächsten Frühling.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;